module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector_oficial-01 2.15052c7e.png";